import { createRoot } from 'react-dom/client'
import './index.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import React, { Suspense } from 'react'
import { Loading } from './router'
import { HelmetProvider } from 'react-helmet-async'

const App = React.lazy(() => import('./App'))

const container = document.getElementById('root')
if (!container) {
  throw new Error('Failed to find the root element')
}

const root = createRoot(container)

/* Redirects to basename */
if (window.location.pathname === '/') {
  window.location.replace('/order')
}

root.render(
  <HelmetProvider>
    <Router basename='/order'>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path='/*' element={<App />} />
        </Routes>
      </Suspense>
    </Router>
  </HelmetProvider>
)
